import { useState, createContext, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate, Link, useNavigate, ScrollRestoration, createBrowserRouter, RouterProvider, Outlet } from 'react-router-dom';
// import App from './App'; // deprecated
import './App.css';

import { googleLogout, useGoogleLogin, GoogleLogin } from '@react-oauth/google';
import axios from 'axios';

import ArtEvent from './components/ArtEvent';
// import RecommendationEvents from './components/RecommendationEvents';
import UserPage from './components/UserPage';
import Users from './components/Users';
import Settings from './components/Settings';
import Notifications from './components/Notifications';
import PersonalArtEvents from './components/PersonalArtEvents';
import AddEvent from './components/AddEvent';
import ArtPage from './components/ArtPage';
import NewArtByLink from './components/NewArtByLink';

import axiosInstance from './axiosInstance.js';
import MyUserContext from './myUserContext.js';
import * as oauth from './oauth.js';

import LogbookHistory from './components/LogbookHistory';
import LogbookPage from './components/LogbookPage';
import RecalcUser from './components/RecalcUser';

import ReactGA from 'react-ga4'; // Import Google Analytics
import NewUser from "./components/NewUser.js";

function MainPage() {
  const [isRussianSpeaking, setIsRussianSpeaking] = useState(true); // TODO

  const [loginState, setLoginState] = useState(null); // also, loggedIn and loggedOut
  const [oauthLoginURL, setOauthLoginURL] = useState(null);

  const [myUserInfo, setMyUserInfo] = useState(null);
  const [myUserSettings, setMyUserSettings] = useState(null);

  // const [jwtObtained, setJWTObtained] = useState(false); // TODO: better use one more loginState (oauthRedirecting?)

  const [unreadCount, setUnreadCount] = useState(null);

  const [selectedTab, setSelectedTab] = useState(0); // profile page is 0, increments to the right
  const [repeatedEnter, setRepeatedEnter] = useState(false);

  const updateMyUserInfo = () => {
    axiosInstance
    .get(`/checkLoggedIn`)
    .then((response) => {     
      setMyUserInfo(response.data);
      setLoginState('loggedIn');
    })
    .catch(error => {
      if (error.response.status === 401) {
        setLoginState('loggedOut');
        // setJWTObtained(false);
      } else {
        // console.error('Error checking login status:', error);  
      }
    });
  }

  const fetchMyUserSettings = () => {
    axiosInstance
    .get(`/user/settings`)
    .then((response) => {
      if (response.status === 200) {
        setMyUserSettings(response.data);
      }
    })
    .catch(error => {
      // console.error('Error checking login status:', error);
    });
  }
  const updateMyUserSettings = (lang, username, avatarUrl) => {
    setMyUserSettings({
      'lang': lang,
      'userName': username,
      'avatarUrl': avatarUrl
    })
  }

  const oauthLoginURLReceivedCallback = (url) => {
    setOauthLoginURL(url);
  }
  const handleLoginWithGoogle = () => {
    window.location.href = oauthLoginURL;
  };

  const fetchUnreadCount = () => {
    axiosInstance
    .get('/notifications/unreadCount')
    .then((response) => {
      setUnreadCount(response.data.unreadCount);
    })
    .catch(error => {
      // console.error('Failed to fetch unread notification count:', error);
    })
  };

  // Google login.
  const [ user, setUser ] = useState(null);
  const login = useGoogleLogin({
      onSuccess: (codeResponse) => setUser(codeResponse),
      onError: (error) => console.log('Login Failed:', error)
  });
  useEffect(
    () => {
        if (user) {
            oauth.ProvideTokenToBackend({token: user.access_token, onJWTObtained: () => {
              // setJWTObtained(true);
              updateMyUserInfo();
              window.location.href = "/";
            }
            });
        }
    },
    [ user ]
  );

  // Initialize Google Analytics
  useEffect(() => {
    ReactGA.initialize('G-SRJGEMSELK'); // Replace with your Google Analytics Measurement ID
    ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search });
  }, []);

  // // TODO: refactor, this block is ugly.
  // let isOauthRedirect = false;
  // const urlParams = new URLSearchParams(window.location.search);
  // const code = urlParams.get('code');
  // if (code !== null) {
  //   isOauthRedirect = true;
  // }

  if (!loginState && !myUserSettings && !unreadCount) {
    updateMyUserInfo();
    fetchMyUserSettings();
    fetchUnreadCount();
    // return <div></div>
  }

  if (!loginState) {
    return <div></div>
  }
  if (loginState === 'loggedIn' && !myUserSettings) { // if logged in, wait for settings
    return <div></div>
  }
  // loginStaet === 'loggedOut' -> myUserSettings are not needed

  // if (loginState === 'unknown' && !isOauthRedirect || (loginState === "loggedIn" && (myUserSettings === null || unreadCount === null))) {
  //   return <div></div>
  // }

  const Layout = ({loggedIn}) => {
    return (
      <div>
        
          <ul class="container fixed h-14 py-1 md:pb-0 md:h-14 bottom-0 md:top-0 border-t md:border-b md:border-t-0 z-[110] w-full px-4 md:px-10 border-gray-300 border-opacity-20 left-1/2 transform -translate-x-1/2 bg-[#18191A] mx-auto inline-block text-center flex justify-between xl:items-center items-center w-5/6 lg:w-3/4 xl:flex xl:justify-between xl:w-2/3 2xl:flex 2xl:justify-between 2xl:w-1/2">
            <li>
              <Link class="" to="/" onClick={()=> { setRepeatedEnter(selectedTab === 0); setSelectedTab(0); }}>
                <div class={`border-t-2 md:border-t-0 md:border-b-2 ${selectedTab === 0 ? "border-white" : "border-transparent"}`}>
                  <img
                    src={myUserSettings?.avatarUrl || "avatar_neutral.jpeg"}
                    class="object-cover w-10 h-10 flex-none rounded-full cursor-pointer"
                    title = {myUserSettings?.lang === "ru" ? "Моя библиотека (мой профиль)" : "My library (my profile)"}
                  />
                </div>
              </Link>
            </li>
            {
            loggedIn &&
            <li>
              <Link class="" to={`/users/${myUserInfo?.myUserId || ""}/recommendationsIncoming`} onClick={()=> { setRepeatedEnter(selectedTab === 1); setSelectedTab(1); }}>
                <div class={`container mx-auto flex justify-center items-center border-t-2 md:border-t-0 md:border-b-2 ${selectedTab === 1 ? "border-white" : "border-transparent"}`}>
                  <img class="mt-0.5 max-w-9 max-h-9" src="/user_peer_icon_3.png"
                  title={myUserSettings?.lang === "ru" ? "Рекомендации между друзьями" : "Recommendations between friends"}
                  />
                </div>
              </Link>
            </li>
            }
            <li>
              <Link class="" to="/addEvent" onClick={()=> { setRepeatedEnter(selectedTab === 2); setSelectedTab(2); }}>
                <div class={`container mx-auto flex justify-center items-center border-t-2 md:border-t-0 md:border-b-2 ${selectedTab === 2 ? "border-white" : "border-transparent"}`}>
                  <div class="flex group-hover:hidden">
                    <img class="mt-0.5 max-w-11 max-h-11" src="/search_icon.png" 
                      title={myUserSettings?.lang === "ru" ? "Поиск произведений" : "Art search"}
                    />
                  </div>
                </div>
              </Link>
            </li>
            <li>
              <Link class="" to="/notifications" onClick={()=> { setRepeatedEnter(selectedTab === 4); setSelectedTab(4); }}>
                <div class={`container mx-auto flex justify-center items-center border-t-2 md:border-t-0 md:border-b-2 ${selectedTab === 4 ? "border-white" : "border-transparent"}`}>
                  <div class="flex group-hover:hidden">
                    <img class="mt-0.5 max-w-9 max-h-9" src="/notification_icon.png" 
                      title={myUserSettings?.lang === "ru" ? "Уведомления" : "Notifications"}
                    />
                    <span class="text-white">
                      {unreadCount ? " (" + unreadCount + ")" : ""}
                    </span>
                  </div>
                </div>
              </Link>
            </li>
          </ul>
        
        <div class="mb-24 md:mb-0 md:mt-16">
          <Outlet />
        </div>
      </div>
    );
  };

  if (loginState === 'loggedOut') {
    const language = 'ru';

    const routerLoggedOut = createBrowserRouter([
      {
        path: "/",
        element: <Layout loggedIn={false}/>,
        children: [
          {
            path: "/",
            element: (
              <div class="flex justify-center mt-4">
                <div class="w-4/5 md:w-2/3">
                  {
                    isRussianSpeaking ?
                    <div>
                      <div class="mb-2">
                        <div class="flex justify-center text-center mb-4 font-medium">
                          Ваша библиотека<br/>
                          Здесь будут появляться произведения, которые вы разметите тэгами
                        </div>
                      </div>
                      <div class="flex justify-center text-center mb-4">
                        <GoogleLogin
                          onSuccess={(credentialResponse) => {
                            oauth.ProvideCredentialToBackend({
                                credential: credentialResponse.credential, 
                                onJWTObtained: () => {
                                  // setJWTObtained(true);
                                  updateMyUserInfo();
                                  window.location.href = "/";
                                }
                            });
                          }}
                          onError={() => {
                            console.log('Login Failed');
                          }}
                        />
                      </div>
                    </div>
                    :
                    <div>
                      <div class="flex justify-center text-center mb-4 font-medium">
                        Your library<br/>
                        Here will be arts you've tagged
                      </div>
                      <div class="flex justify-center">
                        <GoogleLogin
                          onSuccess={(credentialResponse) => {
                            oauth.ProvideCredentialToBackend({
                                credential: credentialResponse.credential, 
                                onJWTObtained: () => {
                                  // setJWTObtained(true);
                                  updateMyUserInfo();
                                  window.location.href = "/";
                                }
                            });
                          }}
                          onError={() => {
                            console.log('Login Failed');
                          }}
                        />
                      </div>
                    </div>
                  }
                </div>
              </div>
            )
          },
          {
            path: "/users",
            element: <Users />
          },
          {
            path: "/addEvent",
            element: <AddEvent />
          },
          {
            path: "/notifications",
            element: <Notifications />
          },
          {
            path: "/arts/:id",
            element: <ArtPage />
          },
          {
            path: "/users/:pathUserId/likes",
            element: <PersonalArtEvents repeatedEnter={repeatedEnter} eventType="like" key="someonesLikes" userId={null} />
          },
          {
            path: "/logbookHistory",
            element: <LogbookHistory />
          },
          {
            path: "/artEvents/:id",
            element: <ArtEvent eventType="artEvent"/>
          },
          {
            path: "/newUser",
            element: <NewUser />
          },
          {
            path: "/artByLink",
            element: <ArtPage />
          }
        ]
      }
    ]);

    return (
      <div class="container mx-auto">
        <RouterProvider router={routerLoggedOut}>
        </RouterProvider>
      </div>
    );
  }

  const routerLoggedIn = createBrowserRouter([
    {
      path: "/",
      element: <Layout loggedIn={true}/>,
      children: [
        {
          path: "/",
          element: <Navigate to={`/users/${myUserInfo.myUserId}/likes`} replace />,
        },
        {
          path: "/addEvent",
          element: <AddEvent repeatedEnter={repeatedEnter}/>
        },
        {
          path: "/users/:pathUserId",
          element: <UserPage userId={null} />
        },
        {
          path: "/users/:pathUserId/likes",
          element: <PersonalArtEvents repeatedEnter={repeatedEnter} eventType="like" key="someonesLikes" userId={null} />
        },
        {
          path: "/users/:pathUserId/recommendationsIncoming",
          element: <PersonalArtEvents repeatedEnter={repeatedEnter} eventType="recommendationIncoming" key="someonesIncomingRecommendations" userId={null} />
        },
        {
          path: "/users/:pathUserId/recommendationsOutgoing",
          element: <PersonalArtEvents eventType="recommendationOutgoing" key="someonesOutgoingRecommendations" userId={null} />
        },
        // {
        //   path: "/recommendations/toMe",
        //   element: <RecommendationEvents key="recomToMe" params={{fromMe: false}} />
        // },
        // {
        //   path: "/recommendations/fromMe",
        //   element: <RecommendationEvents key="recomFromMe"  params={{fromMe: true}} />
        // },
        {
          path: "/users",
          element: <Users />
        },
        {
          path: "/settings",
          element: <Settings onSettingsChange={updateMyUserSettings} />
        },
        {
          path: "/logbookHistory",
          element: <LogbookHistory />
        },
        {
          path: "/artEvents/:id",
          element: <ArtEvent eventType="artEvent"/>
        },
        {
          path: "/logbook",
          element: <LogbookPage />
        },
        {
          path: "/recommendations/:id",
          element: <ArtEvent eventType="recommendation"/>
        },
        {
          path: "/arts/:id",
          element: <ArtPage />
        },
        {
          path: "/notifications",
          element: <Notifications unreadCountCallback={setUnreadCount} />
        },
        {
          path: "/users/:pathUserId/recalc",
          element: <RecalcUser />
        },
        {
          path: "/artByLink",
          element: <ArtPage />
        }
      ]
    }
  ]);

  return (
    <div class="container mx-auto">
      <MyUserContext.Provider value={{myUserInfo: myUserInfo, myUserSettings: myUserSettings}}>
        <RouterProvider router={routerLoggedIn}>
        </RouterProvider>
      </MyUserContext.Provider>
    </div>
  );
  // TODO: Put in footer: Icons by <a target="_blank" href="https://icons8.com">Icons8</a>
}

export default MainPage;